

















































































import { Component, Vue } from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import * as amplitude from 'amplitude-js';
import { ItemDTO } from '@/api';
import { clientsModule, thingsModule } from '@/store';
import ThingOptions from '@/components/things/ThingOptions.vue';
import CheckCard from '@/components/common/CheckCard.vue';
import { WeatherFilterEnum } from '@/store/modules/looks.module';
import { set } from 'date-fns';

@Component({
  name: 'things-page',
  components: {
    BaseLayout,
    ThingOptions,
    CheckCard,
  },
})
export default class ThingsPage extends Vue {
  pickerOptions = {
    disabledDate: (date: Date) => !this.shoppingDays.includes(set(date || 0, {
      hours: 0, minutes: 0, seconds: 0, milliseconds: 0,
    }).valueOf()),
  }

  get loading() {
    return thingsModule.loadingList;
  }

  get multi() {
    return thingsModule.multi;
  }

  set multi(multi: boolean) {
    thingsModule.setMulti(multi);
  }

  get things() {
    return thingsModule.things;
  }

  get selectedThings() {
    return thingsModule.selectedThings;
  }

  get selectedThing() {
    return thingsModule.selectedThings && thingsModule.selectedThings.length
      ? thingsModule.selectedThings[0]
      : undefined;
  }

  get weatherFilter() {
    return thingsModule.weatherFilter;
  }

  set weatherFilter(value: WeatherFilterEnum) {
    thingsModule.setWeatherFilter(value);
  }

  get temperatureFrom() {
    return thingsModule.tempFilter[0];
  }

  set temperatureFrom(temp: number) {
    if (temp > this.temperatureTo) {
      this.temperatureTo = temp;
    }
    thingsModule.setTemp([temp, this.temperatureTo]);
  }

  get temperatureTo() {
    return thingsModule.tempFilter[1];
  }

  set temperatureTo(temp: number) {
    if (temp < this.temperatureFrom) {
      this.temperatureFrom = temp;
    }
    thingsModule.setTemp([this.temperatureFrom, temp]);
  }

  get client() {
    return clientsModule.model;
  }

  get groupByCategory() {
    return thingsModule.groupByCategory;
  }

  get dateFilter() {
    return thingsModule.dateFilter;
  }

  set dateFilter(date: number | null) {
    thingsModule.setDateFilter(date);
  }

  get shoppingDays() {
    return thingsModule.shoppingDays;
  }

  created() {
    if (this.client && this.client.id != null) {
      thingsModule.fetchThings(this.client.id);
      amplitude.getInstance().logEvent('Открыта страница вещей клиента', { clientId: this.client.id });
    }
  }

  select(id: number) {
    if (!this.multi) {
      thingsModule.setSelected([id]);
    } else {
      const index = thingsModule.selected.indexOf(id);
      if (index > -1) {
        thingsModule.setSelected([
          ...thingsModule.selected.slice(0, index),
          ...thingsModule.selected.slice(index + 1),
        ]);
      } else {
        thingsModule.setSelected(thingsModule.selected.concat(id));
      }
    }
    if (thingsModule.selected.length === 0) {
      this.multi = false;
    }
  }

  isSelected(id: number) {
    return thingsModule.selected.includes(id);
  }

  getImage(item: ItemDTO) {
    return item.fileNames && item.fileNames.length
      ? item.fileNames[0].fileName
      : null;
  }

  handleAddButton(command: 'form' | 'catalog' | 'neuralNetwork') {
    if (command === 'form') {
      this.$router.push({ name: 'add-things' });
    }
    if (command === 'catalog') {
      this.$router.push({ name: 'client-things-catalog' });
    }
    if (command === 'neuralNetwork') {
      this.$router.push({ name: 'ai-things' });
    }
  }

  resetSelected() {
    thingsModule.resetSelect();
  }
}
